// Self-contained data for the Meking Law Firm concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/03_Meking_Law_Firm (research snapshot 2026-08-21).
// Atty. Meking's identity as a lawyer is independently confirmed (official Bar passer list;
// Supreme Court case Meking v. Remulla, G.R. No. 280455, Nov 11 2025). Broader academic/media
// claims below are self-published per her public profile and are framed as such, not as
// independently verified fact. Do not present "largest law firm in North Luzon" as a ranking —
// it is self-published marketing from a branch social mirror and is omitted here.
export const BIZ = {
  name: "Meking Law Firm",
  tagline: "Legal Advocacy With Clarity and Experience",
  qcAddress: "36 Mariposa Street, Quezon City 1111",
  pampangaAddress: "Angeles City, Pampanga (branch)",
  phone: "+639850332371",
  phoneDisplay: "+63 985 033 2371",
  facebook: "https://www.facebook.com/226239400581126",
  mapEmbed: "https://www.google.com/maps?q=36+Mariposa+Street+Quezon+City&output=embed",
};

export const PRACTICE_AREAS = [
  { title: "Civil Law", text: "Civil matters and general civil litigation." },
  { title: "Corporate & Business Law", text: "Legal support for companies and business concerns." },
  { title: "Criminal Law & Litigation", text: "Criminal defense and litigation representation." },
  { title: "Family Law", text: "Family matters, including divorce-related and VAWC concerns." },
  { title: "Labor & Employment", text: "Labor and employment-related legal matters." },
  { title: "Property & Land Title", text: "Land-title processing and property administration concerns." },
  { title: "Tax Law", text: "Tax-related legal matters." },
  { title: "Legal Documents", text: "General legal-document preparation and services." },
];

// Self-published academic/media background from her public professional profile — presented
// as her stated background, not independently verified beyond her confirmed Bar admission.
export const BIO = {
  role: "Owner, Managing Partner & Senior Partner",
  confirmed: "My admission to the Philippine Bar is independently confirmed by the official Bar passer list. I'm also the respondent named in the Supreme Court case Meking v. Remulla (G.R. No. 280455, Nov. 11, 2025), and in 2025 I publicly challenged DOJ Department Circular No. 015 before the Supreme Court.",
  selfDescribed: "My public professional profile additionally describes credentials including AB, MPA, JD and PhD studies, litigation practice, criminology teaching, and lecturing on special laws and cybercrime, along with media, newswriting and radio experience. These are self-published details from my own profile and have not been independently verified beyond my confirmed Bar admission.",
};

export const TEAM_NOTE = "Cesar Patrick Bonales has publicly listed a Marketing and PR Consultant role with us since 2022.";

export const REPUTATION = {
  rating: "5.0",
  reviewCountLabel: "50+ public reviews",
  note: "Current structured listings show roughly 52 reviews; an earlier law-firm dataset showed 33. Individual review text was not recoverable — the rating reflects the aggregate shown in current public listings.",
};
